<template>
    <div class="layout-container">
        <el-tabs type="border-card">
            <el-tab-pane label="通话记录">
                <div style="background: #ffffff;position:relative;">
                    <div class="search-condition-con search-condition-first" :class="isShowMore && 'show'">
                        <div class="search-condition">
                            <span class="label">代理商</span>
                            <div class="input-condition">
                                <factor-auto-complete v-model="condition.factor_id" clearable></factor-auto-complete>
                            </div>
                        </div>
                        <div class="search-condition">
                            <span class="label">站点</span>
                            <div class="input-condition">
                                <site-auto-complete v-model="condition.site_id"  :owned="true" :factor-id="condition.factor_id" clearable></site-auto-complete>
                            </div>
                        </div>
                        <div class="search-condition">
                            <span class="label">楼盘</span>
                            <div class="input-condition">
                                <house-auto-complete v-model="condition.house_id" :site-id="condition.site_id"></house-auto-complete>
                            </div>
                        </div>
                        <div class="search-condition">
                            <span class="label">电话类型</span>
                            <div class="input-condition">
                                <el-select   v-model="condition.hotline_type">
                                    <el-option value="0" label="全部">全部</el-option>
                                    <el-option value="1" label="公共大号">公共大号</el-option>
                                    <el-option value="2" label="独立大号">独立大号</el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="search-condition">
                            <span class="label">400号码</span>
                            <div class="input-condition">
                                <el-input placeholder="请输入400号码" class="input-control" v-model="condition.hotline_number"></el-input>
                            </div>
                        </div>
                        <div class="search-condition">
                            <span class="label">分机号</span>
                            <div class="input-condition">
                                <el-input placeholder="请输入分机号" class="input-control" v-model="condition.telephone_number"></el-input>
                            </div>
                        </div>
                        <div class="search-condition">
                            <span class="label">来电号码</span>
                            <div class="input-condition">
                                <el-input placeholder="请输入来电号码" class="input-control" v-model="condition.call_phone"></el-input>
                            </div>
                        </div>
                        <div class="search-condition">
                            <span class="label">坐席号码</span>
                            <div class="input-condition">
                                <el-input placeholder="请输入坐席号码" class="input-control" v-model="condition.staff_phone"></el-input>
                            </div>
                        </div>
                        <div class="search-condition">
                            <span class="label">接听状态</span>
                            <div class="input-condition">
                                <el-select  v-model="condition.answer_status">
                                    <el-option value="-1" label="全部">全部</el-option>
                                    <el-option value="0" label="座席接听">座席接听</el-option>
                                    <el-option value="1" label="忙">忙</el-option>
                                    <el-option value="2" label="无应答">无应答</el-option>
                                    <el-option value="3" label="客户提前挂机">客户提前挂机</el-option>
                                    <el-option value="11" label="客户主动放弃">客户主动放弃</el-option>
                                    <el-option value="201" label="无效分机号">无效分机号</el-option>
                                    <el-option value="555" label="黑名单">黑名单</el-option>
                                    <el-option value="777" label="回呼外线失败">回呼外线失败</el-option>
                                    <el-option value="1000" label="非工作时间">非工作时间</el-option>
                                    <el-option value="1002" label="欠费">欠费</el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="search-condition search-condition-time">
                            <span class="label">时间段</span>
                            <div class="input-condition">
                                <el-date-picker
                                    v-model="condition.time"
                                    type="datetimerange"
                                    range-separator="至"
                                    start-placeholder="请选择开始日期"
                                    end-placeholder="请选择结束日期"
                                    align="right"
                                    >
                                </el-date-picker>
                            </div>
                        </div>
                    </div>
                    <a class="el-icon-d-arrow-left search-arrow-down" :class="!isShowMore && 'hide'" @click.stop="isShowMore = !isShowMore"></a>
                    <div class="btn-condition">
                        <el-button type="primary" @click="handleSearch()">查 询</el-button>
                        <el-button  @click="resetSearch()">清空条件</el-button>
                    </div>
                </div>

                <div class="clearfix" style="margin-bottom: 5px">
                    <el-button-group class="floatR">
                        <el-tooltip class="item" effect="dark" content="导出" placement="top">
                            <el-button icon="el-icon-download" @click="download"></el-button>
                        </el-tooltip>
                    </el-button-group>
                </div>
                <el-table
                    :data="list"
                    style="width: 100%"
                    :highlight-current-row="true"
                    stripe
                    tooltip-effect="dark"
                    ref="multipleTable"
                    v-loading="isLoading"
                    header-cell-class-name="table-back"
                >
                    <el-table-column  label="ID" prop="id" fixed width="80px"></el-table-column>
                    <el-table-column  label="来电号码" prop="call_phone" width="120px"></el-table-column>
                    <el-table-column  label="代理商" prop="factor_name" width="180px"></el-table-column>
                    <el-table-column  label="站点" prop="site_name" width="120px"></el-table-column>
                    <el-table-column  label="对应楼盘" prop="house_name" width="150px"></el-table-column>
                    <el-table-column  label="400号码" prop="hotline_number" width="120px"></el-table-column>
                    <el-table-column  label="转接号" prop="telephone_number"></el-table-column>
                    <el-table-column  label="坐席号码" prop="staff_phone" width="120px"></el-table-column>
                    <el-table-column  label="开始时间/结束时间" width="180px">
                        <template slot-scope="scope">
                            <p v-html="scope.row.time_str"></p>
                        </template>
                    </el-table-column>
                    <el-table-column  label="通话时长(秒)" prop="call_duration" width="100px"></el-table-column>
                    <el-table-column  label="费用(元)" prop="paid_amount_format_yuan"></el-table-column>
                    <el-table-column  label="接听状态" prop="answer_status_name" width="120px"></el-table-column>
                    <el-table-column  label="录音">
                        <template slot-scope="scope">
                            <Permission allowed="data.call-record.list.voice" isRow="1">
                            <i class="el-icon-video-play play-phone-audio" @click="playAudio(scope.row)" v-if="scope.row.tape_url != ''"></i>
                            </Permission>
                        </template>
                    </el-table-column>
                    <el-table-column  label="操作" width="280px"  fixed="right">
                        <template slot-scope="scope">
                            <el-button size="mini" @click="toConverDetail(scope.row)" v-if="scope.row.telephone_number != ''" v-permission="'data.call-record.list.log'">转接详情</el-button>
                            <el-button size="mini" @click="addBlack(scope.$index, scope.row)" v-permission="'data.call-record.list.black-list'">添加黑名单</el-button>
                            <a class="el-button el-button--default el-button--mini decoration-none" :underline="false" size="mini" :href="scope.row.voice_url"  :download="scope.row.id" v-if="scope.row.tape_url != ''" v-permission="'data.call-record.list.voice'">下载</a>
                        </template>
                    </el-table-column>
                </el-table>
                <template v-if="list.length > 0">
                    <el-pagination background layout="total,prev, pager, next" :current-page="condition.page"  :total="condition.total" :page-size="condition.per_page" @current-change="currentChange"></el-pagination>
                </template>

                <!-- 播放通话录音 -->
                <el-dialog title="播放通话录音" :visible.sync="isPlayAudio" width="30%" :center="true" :close="onClose">
                    <audio id="audio" controls preload></audio>
                    <div class="phone-btn-list">
                        <el-button @click="closePlay">关闭</el-button>
                        <a v-if="currentAudio.url != ''" :href="currentAudio.url"  :download="currentAudio.id" class="el-button el-button--primary el-button--medium decoration-none">下载</a>
                    </div>
                </el-dialog>

                <!-- 转换详情 -->
                <el-dialog :visible.sync="isShowConvert" width="40%" :center="true" custom-class="phone-conver-dialog" title="转接详情">
                    <el-table
                        :data="convertList"
                        style="width: 100%"
                        :highlight-current-row="true"
                        stripe
                        tooltip-effect="dark"
                        header-cell-class-name="table-back"
                    >
                        <el-table-column  label="开始时间" prop="startdate"></el-table-column>
                        <el-table-column  label="拨入电话" prop="ani"></el-table-column>
                        <el-table-column  label="转接电话" prop="dni"></el-table-column>
                        <el-table-column  label="结果" prop="callresult"></el-table-column>
                        <el-table-column  label="持续时间(秒)" prop="calltime"></el-table-column>
                    </el-table>
                </el-dialog>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
    import {getFactorsByName} from '@/service/user'
    import {getSite} from '@/service/site'
    import {getHouses} from '@/service/housedict'
    import {getUser} from '@/utils/auth'
    import {getCallrecord, addBlackList, getCallrecordLog, getCallrecordVoice, getVoiceUrl} from '@/service/hotline'
    import { parseTime } from '@/utils'
    import FactorAutoComplete from "../../../components/auto-complete/factor-auto-complete";
    import SiteAutoComplete from "../../../components/auto-complete/site-auto-complete";
    import HouseAutoComplete from "../../../components/auto-complete/house-auto-complete";

export default {
    name: 'DataPhoneList',
    components: {HouseAutoComplete, SiteAutoComplete, FactorAutoComplete},
    data () {
        return {
            list: [],
            convertList: [],
            loading:false,
            isShowMore: false,
            isLoading: false,
            isPlayAudio: false,
            isShowConvert: false,
            currentAudio: {
                url: '',
                id: ''
            },
            condition: {}
        }
    },
    mounted (){
        this.condition = this.defaultConditions()
        this.initData()
    },
    methods: {
        defaultConditions () {
            return {
                page :1,
                per_page : 10,
                total : 0,
                factor_id: 0,
                site_id: 0,
                house_id: '',
                hotline_type : '0',
                telephone_number : '',
                hotline_number : '',
                call_phone : '',
                staff_phone : '',
                answer_status : '-1',
                time : []
            }
        },
        addBlack (index, row){
            this.$confirm("确定将"+row.call_phone+"加入黑名单吗？", '提示').then(_ => {
                let query = {
                    phone : row.call_phone
                }
                addBlackList(query).then((data) => {
                    this.$message({
                        message: '添加成功',
                        type: 'success',
                        duration: 3 * 1000
                    })
                }).catch(err => {
                    this.$message({
                        message: '添加失败' + err.message,
                        type: 'error',
                        duration: 3 * 1000
                    })
                })
            }).catch(_ => {

            })
        },
        resetSearch(){
            this.condition = this.defaultConditions()
            this.initData()
        },
        handleSearch() {
            this.condition.page = 1
            this.initData()
        },
        async initData () {
            this.list = []
            // 初始化之前设置当前页面的loading状态
            this.isLoading = true
            let query = Object.assign({}, this.condition)
            query.time = null
            if (this.condition.time.length > 0) {
                query.call_in_time_at_start = new Date(this.condition.time[0]).getTime()/1000
                query.call_in_time_at_end = new Date(this.condition.time[1]).getTime()/1000
            }
             try {
               await getCallrecord(query).then((data) => {
                this.condition.total= parseInt(data.total)
                this.condition.per_page = parseInt(data.per_page)
                let listData = data.data
                for (let i in listData) {
                    let row = listData[i]
                    row.time_str = '<p>'+row.call_in_date_at + '</p>'
                    if (row.answer_end_date_at.length > 0) {
                        row.time_str += '<p>'+row.answer_end_date_at + '</p>'
                    }
                    row.voice_url = getVoiceUrl(row.id)
                }
                this.list = listData
            })
            // 数据请求完毕取消当前页面的loading
            this.isLoading = false
            } catch (error) {
                console.log('on play error:', error)
                this.isLoading = false
            }



           
        },
        currentChange (index) {
            this.condition.page = index
            this.initData()
        },
        playAudio (data) {
            try {
                this.isPlayAudio = true
                this.$nextTick(() => {
                    const audio = document.getElementById('audio')
                    const path = getVoiceUrl(data.id)
                    console.log('path:', path)
                    this.currentAudio = {
                        url: path,
                        id: data.id
                    }
                    audio.setAttribute('src', path)
                    audio.play()
                })
            } catch (error) {
                console.log('on play error:', error)
            }
        },
        onClose () {
            try {
                const audio = document.getElementById('audio')
                audio.pause()
                audio.setAttribute('src', '')
                this.isPlayAudio = false
                this.currentAudio = {
                    url: '',
                    id: ''
                }
            } catch (error) {
                console.log('on close error:', error)
            }
        },
        closePlay(){
            this.onClose()
            this.isPlayAudio=false
        },
        toConverDetail (data) {
            this.convertList = []
            getCallrecordLog(data.id, {}).then((data) => {
                this.convertList = data
                this.isShowConvert = true
            }).catch(err => {
                console.log(toConverDetail)
                this.$message({
                    message: '获取失败' + err.message,
                    type: 'error',
                    duration: 3 * 1000
                })
            })
        },
        download(){
            if (this.condition.time.length == 0) {
                this.$message({
                    message: '请选择时间段',
                    type: 'error',
                    duration: 3 * 1000
                })
                return false
            }
            import('@/vendor/Export2Excel').then(async excel => {
                const tHeader = ["编号","代理商","站点","对应楼盘","400号码","转接号","来电号码","坐席号码","开始时间/结束时间","通话时长(秒)","费用(元)","接听状态"]
                const filterVal = ['id','factor_name', 'site_name', 'house_name', 'hotline_number','telephone_number','call_phone','staff_phone','time_str','call_duration', 'paid_amount_format', 'answer_status_name']
                let list = []
                let query = Object.assign({}, this.condition)
                query.time = null
                if (this.condition.time.length > 0) {
                    query.call_in_time_at_start = new Date(this.condition.time[0]).getTime()/1000
                    query.call_in_time_at_end = new Date(this.condition.time[1]).getTime()/1000
                }
                this.isLoading = true
                // 模拟fetch请求数据....
                await getCallrecord(query).then((data) => {
                    let listData = data.data
                    for (let i in listData) {
                        let row = listData[i]
                        row.time_str = row.call_in_date_at
                        if (row.answer_end_date_at.length > 0) {
                            row.time_str += '至'+row.answer_end_date_at
                        }
                    }
                    list = listData
                })
                const formatJson = (filterVal) => {
                    return list.map(v => filterVal.map(j => {
                        return v[j]
                    }))
                }
                let name = '通话记录'
                if (this.condition.time.length > 0) {
                    name += parseTime( new Date(this.condition.time[0]), '{y}-{m}-{d}') + '至' + parseTime( new Date(this.condition.time[1]), '{y}-{m}-{d}')
                }
                const data = formatJson(filterVal)
                excel.export_json_to_excel({
                    header: tHeader,
                    data,
                    filename: name
                })
                this.isLoading = false
            })
        },
    }
}
</script>
<style scoped lang="less">
.play-phone-audio{
    cursor: pointer;
    font-size: 21px;
}
audio{
    display: block;
    margin: 0 auto;
    outline: 0;
}
.phone-btn-list{
    text-align: center;
    margin-top: 40px;
}
.decoration-none{
    text-decoration: none;
}
</style>
